import { Form } from "@/shared/form/Form";
import { FormFieldType } from "@/shared/form/FormDefinition";

/**
 * `content.task` — Aufgabenstellung of the Bauwerksbuch report.
 *
 * Exactly the four subsections of the Bauwerksbuch, a different set from the
 * Aufgabenstellung of the existing report. The guidelines and the provided
 * documents arrive as Markdown lists flattened from the two list-typed catalog
 * fields and stay editable as text per report.
 *
 * No label carries a chapter number: the chapter structure may change, and the
 * numbering the PDF prints comes from the backend chapter plan at render time.
 */
export interface BauwerksbuchTaskFormData {
  applicationField: string;
  guidelines: string;
  commissionBasis: string;
  providedDocuments: string;
}

export class BauwerksbuchTaskForm extends Form<BauwerksbuchTaskFormData> {
  protected definition = {
    applicationField: {
      label: "Anwendungsbereich",
      type: FormFieldType.Text,
      required: false
    },
    guidelines: {
      label: "Herangezogene Richtlinien",
      type: FormFieldType.Text,
      required: false
    },
    commissionBasis: {
      label: "Beauftragungsgrundlagen",
      type: FormFieldType.Text,
      required: false
    },
    providedDocuments: {
      label: "Für die Begehung bereit gestellte Unterlagen",
      type: FormFieldType.Text,
      required: false
    }
  };
}
